import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { cn } from '../../utils/cn';
export const Carousel = React.forwardRef(({ children, 'aria-label': ariaLabel }, ref) => {
    const slideRefs = useRef([]);
    React.useImperativeHandle(ref, () => ({
        slideGoTo: (index) => {
            slideRefs.current[index]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        },
    }), []);
    return (_jsx("ul", { 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- WAI-ARIA scrollable region pattern: must stay focusable for keyboard-driven scrolling
        tabIndex: 0, "aria-label": ariaLabel ?? 'Slides', className: "scrollbar-hidden m-0 grid snap-x snap-mandatory list-none auto-cols-[100%] grid-flow-col gap-x-5 overflow-x-auto scroll-smooth p-0", children: React.Children.map(children, (child, index) => (_jsx("li", { ref: (el) => {
                slideRefs.current[index] = el;
            }, tabIndex: -1, className: "relative h-full snap-center snap-always", children: child }))) }));
});
Carousel.displayName = 'Carousel';
export const Bullet = ({ isActive, onClick, ...props }) => (_jsx("button", { type: "button", onClick: onClick, className: "group cursor-pointer appearance-none border-0 bg-transparent p-2 outline-none", ...props, children: _jsx("span", { className: cn('bg-dep-secondary group-focus-visible:focus-ring-dep-thin block h-4 w-4 rounded-full transition-transform duration-130 ease-in-out', isActive && 'bg-dep-tertiary scale-125') }) }));
